import { ep } from './numbers';
import { SankeyNode } from './types';

// Find everything which shares the class of the dragged Node and
// translate all of them with these offsets.
// Currently this means the Node and the label+highlight, if present.
export function getNodeTransform(node: SankeyNode): string {
  const translateX = ep((node.x ?? NaN) - (node.origPos?.x ?? NaN));
  const translateY = ep((node.y ?? NaN) - (node.origPos?.y ?? NaN));
  return `translate(${translateX},${translateY})`;
}
